import 'i18n/index'; // self-bootstraps from window.__locale_data before anything else evaluates
import 'pages/siteHeader';
import 'pages/sitePage';
import 'pages/auth.jsx';
import 'pages/documentation.jsx';
import 'pages/authentication.jsx';
import 'pages/blog.jsx';
import 'pages/reports.jsx';
import 'pages/game_scoring.jsx';
import 'pages/graphs.jsx';
import 'pages/mod_chats.jsx';
import 'pages/mod_user_bugs.jsx';
import 'pages/external_keys.jsx';
import 'pages/stats.jsx';




var comfyText = (function() {
	const tag = $('textarea.elastic');

	function autoExpand(e, el) {
		el = el || e.target;
		el.style.height = 'inherit';
		el.style.height = el.scrollHeight + 'px';
	}

	$.each(tag, function(i, tag) {
		tag.addEventListener('paste', autoExpand);
		tag.addEventListener('input', autoExpand);
		tag.addEventListener('keyup', autoExpand);
	});
	window.addEventListener('load', expandAll);

	function expandAll() {
		$.each(tag, function(i, tag) {
			autoExpand(null, tag[i]);
		});
	}
})();